import { Select as SelectInput, SelectOption as Option } from 'ui-kit-sber'
import styled from 'styled-components'
import { r } from '@utils/styles/functions'

const Select = styled(SelectInput)`
  &.sber-select {
    &:not(.ant-select-disabled).ant-select-open {
      .ant-select {
        &-selector {
          background-color: ${(props) => props.theme.colors.black};
          color: white;
        }

        &-selection-placeholder {
          color: ${(props) => props.theme.colors.white};
        }
      }
    }

    .ant-select {
      &-selection-placeholder {
        color: ${(props) => props.theme.colors.gray};
      }
    }

    .ant-select-selection-item {
      font-size: 16px;
      padding-right: 24px;
    }
  }
`

const SelectOption = styled(Option)``

Select.displayName = 'Select'
SelectOption.displayName = 'SelectOption'

export { Select, SelectOption }
